module.exports = __webpack_public_path__ + "static/videoplayback_4-999160aa95acdb83c2b062603c3fafb3.mp4";